'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleBarBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  disabled: _propTypes2.default.bool,
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  labelPosition: 'left',
  disabled: false
};

/** PROP RECEIVERS */
var positionProps = function positionProps(_ref) {
  var labelPosition = _ref.labelPosition;

  var spacingLeft = labelPosition === 'left' || !labelPosition ? 'auto' : '0',
      spacingRight = labelPosition === 'left' ? '0' : 'auto';

  return '\n    left: ' + spacingLeft + ';\n    right: ' + spacingRight + ';\n  ';
};

var sizeProps = function sizeProps(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var width = theme.reactackle.components.toggleButton.toggleBar.width,
      size = theme.reactackle.components.toggleButton.toggleThumb.size;


  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
};

var disabled = function disabled(_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? '\n      &,\n      & * {\n        cursor: default;\n      }\n    ' : '\n      &,\n      & * {\n        cursor: pointer;\n      }\n    ';
};

/** STYLES */
var ToggleBarBoxStyled = exports.ToggleBarBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ToggleBarBoxStyled'
})(['position:absolute;top:0;', ';', ';', ';'], positionProps, sizeProps, disabled);

ToggleBarBoxStyled.propTypes = propTypes;
ToggleBarBoxStyled.defaultProps = defaultProps;
ToggleBarBoxStyled.displayName = 'ToggleBarBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-toggle-button/dist/styles/ToggleBarBoxStyled.js
// module id = 865
// module chunks = 0